<div class="communication-panel-container">

  <div class="panel-header">
    <button
        class="btn btn-outline align-items-left"
        routerLink="/admin">
        <i class="bi bi-arrow-left "></i>
        Back to Admin Dashboard
         <style> i:hover { -webkit-text-stroke: 1px; } </style>
    </button>

    <h2 class="align-items-left">Client & Drafter Communications</h2>
  </div>

  <div *ngIf="isLoadingQuestions" class="loading-indicator">
    <p>Loading questions...</p>
  </div>

  <div *ngIf="!isLoadingQuestions && questions.length === 0" class="empty-state">
    <p>No communications to display at the moment.</p>
  </div>

  <div class="content-area" *ngIf="!isLoadingQuestions && questions.length > 0">
    <!-- Questions List -->
    <div class="questions-table-wrapper" *ngIf="!selectedQuestion">
      <div class="table-header">
        <div class="filters-container">
          <input
            type="text"
            placeholder="Search by text, ID or author..."
            [ngModel]="searchText"
            (ngModelChange)="onSearchInput($event)"
            class="search-input"
          />

          <select [(ngModel)]="selectedStatus" class="filter-dropdown">
            <option value="all">All statuses</option>
            <option value="new">New</option>
            <option value="answered">Answered</option>
            <option value="pending_customer">Pending Customer</option>
          </select>

          <select [(ngModel)]="sortOrder" class="filter-dropdown">
            <option value="newest">Newest first</option>
            <option value="oldest">Oldest first</option>
          </select>

          <button
            class="btn btn-secondary"
            (click)="clearFilters()"
            [disabled]="!searchText && selectedStatus === 'all' && sortOrder === 'newest'">
            Clear Filters
          </button>
        </div>
      </div>

      <div *ngIf="noResultsFound" class="no-results">
        <p>No questions found matching your search criteria.</p>
      </div>

      <table class="questions-table" *ngIf="!noResultsFound && filteredQuestions.length > 0">
        <thead>
          <tr>
            <th>ID</th>
            <th>Text</th>
            <th>Status</th>
            <th>Author</th>
            <th>Last Update</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let question of filteredQuestions" (click)="selectQuestion(question)">
            <td>#{{ question.id }}</td>
            <td>{{ question.text | slice:0:50 }}{{ question.text.length > 50 ? '...' : '' }}</td>
            <td>
              <span class="status" [ngClass]="getStatusClass(question.status)">
                {{ question.status | titlecase }}
              </span>
            </td>
            <td>{{ question.authorName }}</td>
            <td>{{ question.updatedAt | date:'dd MMM, yyyy' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Selected Question Detail -->
    <div class="question-detail" *ngIf="selectedQuestion" [class.full-screen]="selectedQuestion">
      <button class="close-btn" (click)="closeDetailView()" aria-label="Close detail view">&times;</button>
      <h3>{{ selectedQuestion!.authorName }} ({{ selectedQuestion!.authorRole | titlecase }})</h3>
      <div class="detail-content ">
        <p><strong >Status:   </strong>
          <select
            [(ngModel)]="selectedQuestion!.status"
            (ngModelChange)="onStatusChange(selectedQuestion!, $event)"
            class="status-dropdown "
            [ngClass]="getStatusClass(selectedQuestion!.status)">
            <option value="new">New</option>
            <option value="answered">Answered</option>
            <option value="pending_customer">Pending</option>
          </select>
        </p>

        <!-- Original Question Chat (Drafter/Admin) -->
        <div class="question-chat">
          <!-- Chat Thread Start -->
          <div class="chat-thread">
            <ng-container *ngFor="let msg of getChatThread(selectedQuestion)">
              <!-- Original Message -->
              <div class="chat-message" [ngClass]="{
                'user-message': msg.authorRole === 'drafter' || msg.authorRole === 'customer-admin',
                'admin-message': msg.authorRole === 'admin'
              }">
                <div class="bubble">
                  <div class="message-header">
                    <strong>
                      {{ msg.authorName }}
                      <span *ngIf="msg.authorRole === 'admin'">(Admin)</span>
                      <span *ngIf="msg.authorRole === 'customer-admin'">(Customer-Admin)</span>
                    </strong>
                    <span class="time">{{ msg.updatedAt | date:'short' }}</span>
                  </div>
                  <p class="message-text">{{ msg.text }}</p>
                </div>
              </div>
              <!-- Admin's Response (if exists) -->
              <div *ngIf="msg.adminResponse" class="chat-message admin-response-message">
                <div class="bubble admin-response-bubble">
                  <div class="message-header">
                    <strong>Admin's Response</strong>
                    <span class="time">{{ msg.updatedAt | date:'short' }}</span>
                  </div>
                  <p class="message-text">{{ msg.adminResponse }}</p>
                  <img *ngIf="msg.photo" [src]="msg.photo" alt="Attached image" class="message-image" />
                </div>
              </div>
            </ng-container>
          </div>

          <!-- Answer Form -->
          <div *ngIf="showAnswerForm" class="answer-form">
            <textarea
              [(ngModel)]="answerText"
              placeholder="Enter your answer..."
              rows="3">
            </textarea>
            <label for="imageUpload" class="upload-label">
              Attach image
              <input
                type="file"
                id="imageUpload"
                (change)="onImageSelected($event)"
                accept="image/*"
                hidden />
            </label>
            <div *ngIf="attachedImagePreview" class="image-preview">
              <img [src]="attachedImagePreview" alt="Preview" />
              <button (click)="removeAttachedImage()" class="remove-image-btn">Remove</button>
            </div>
            <div class="actions">
              <button (click)="sendAnswer(selectedQuestion)">Send Answer</button>
              <button (click)="cancelReply()">Cancel</button>
            </div>
          </div>

          <!-- Action Buttons -->
          <div *ngIf="!showAnswerForm && !showClarifyForm" class="actions">
            <button (click)="answerQuestion(selectedQuestion)">Answer</button>
            <button (click)="showClarifyForm = true">Clarify with Customer-Admin</button>
          </div>
        </div>

        <!-- Chat with selected Customer Admin (only if no customer-admin messages for this issue yet) -->
        <div *ngIf="selectedCustomerAdminChat && getCustomerAdminChatsForIssue(selectedQuestion).length === 0" class="selected-customer-admin-chat">
          <h4>Chat with {{ selectedCustomerAdminChat.name }}</h4>

          <div class="chat-messages">
            <div *ngFor="let msg of getCustomerAdminChatMessages()">
              <div class="chat-message" [ngClass]="{
                'admin-message': msg.authorRole === 'admin',
                'customer-admin-message': msg.authorRole === 'customer-admin'
              }">
                <div class="bubble">
                  <div class="message-header">
                    <strong>{{ msg.authorName }}</strong>
                    <span class="message-time">{{ msg.updatedAt | date:'short' }}</span>
                  </div>
                  <p class="message-text">{{ msg.text }}</p>
                  <img *ngIf="msg.photo" [src]="msg.photo" alt="Attached image" class="message-image" />
                </div>
              </div>
            </div>
          </div>

          <textarea
            [(ngModel)]="answerText"
            placeholder="Enter your answer..."
            rows="3">
          </textarea>

          <label for="imageUploadClarify" class="upload-label">
            Attach image
            <input
              type="file"
              id="imageUploadClarify"
              (change)="onImageSelected($event)"
              accept="image/*"
              hidden />
          </label>

          <div *ngIf="attachedImagePreview" class="image-preview">
            <img [src]="attachedImagePreview" alt="Preview" />
            <button (click)="removeAttachedImage()" class="remove-image-btn">Remove</button>
          </div>

          <div class="actions">
            <button (click)="sendClarification(selectedQuestion)"
                    [disabled]="!clarificationText.trim() && !attachedImageFile">
              Send
            </button>
            <button (click)="cancelReply()">Cancel</button>
          </div>
        </div>


        <!-- Customer Admin Chat Block (per issue) -->
        <ng-container *ngIf="getCustomerAdminChatsForIssue(selectedQuestion).length > 0">
          <div class="customer-admin-chat-block" *ngFor="let ca of getCustomerAdminsForIssue(selectedQuestion)">
            <div class="customer-admin-chat">
              <div class="chat-header">
                <h4>Chat with {{ ca.name }}</h4>
              </div>
              <div class="chat-messages">
                <div *ngFor="let msg of getCustomerAdminChatMessagesForIssue(selectedQuestion, ca)"
                     class="chat-message"
                     [ngClass]="{
                       'admin-message': msg.authorRole === 'admin',
                       'customer-admin-message': msg.authorRole === 'customer-admin'
                     }">
                  <div class="bubble">
                    <div class="message-header">
                      <strong>{{ msg.authorName }}</strong>
                      <span class="message-time">{{ msg.updatedAt | date:'short' }}</span>
                    </div>
                    <p class="message-text">{{ msg.text }}</p>
                    <img *ngIf="msg.photo" [src]="msg.photo" alt="Attached image" class="message-image" />
                  </div>
                </div>
              </div>
              <div class="chat-input">
                <ng-container *ngIf="isCustomerAdminActive(ca); else adminDeleted">
                  <textarea
                    [(ngModel)]="answerText"
                    placeholder="Enter your answer..."
                    rows="3">
                  </textarea>
                  <div class="input-actions">
                    <label for="customerAdminImageUpload-{{ca.id}}" class="upload-label">
                      Attach image
                      <input
                        type="file"
                        id="customerAdminImageUpload-{{ca.id}}"
                        (change)="onImageSelected($event)"
                        accept="image/*"
                        hidden />
                    </label>
                    <div *ngIf="attachedImagePreview" class="image-preview">
                      <img [src]="attachedImagePreview" alt="Preview" />
                      <button (click)="removeAttachedImage()" class="remove-image-btn">Remove</button>
                    </div>
                    <button (click)="sendClarificationToCustomerAdmin(selectedQuestion, ca)"
                            [disabled]="!clarificationText.trim() && !attachedImageFile">
                      Send
                    </button>
                  </div>
                </ng-container>
                <ng-template #adminDeleted>
                  <div class="admin-deleted-message">
                    This customer admin is no longer available for new messages.
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- If no customer-admin chat exists for this issue, show clarify form/button -->
        <div *ngIf="getCustomerAdminChatsForIssue(selectedQuestion).length === 0 && showClarifyForm && !selectedCustomerAdminChat" class="clarify-form">
          <h4>Select Customer Admin to Clarify With</h4>
          <select
            [(ngModel)]="selectedCustomerAdminId"
            (change)="onCustomerAdminSelect($event)"
            class="customer-admin-select">
            <option [ngValue]="null" disabled selected>Select customer admin...</option>
            <option *ngFor="let admin of customerAdmins" [value]="admin.id">{{ admin.name }}</option>
          </select>
          <div class="actions">
            <button (click)="cancelReply()">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>